import { UserType } from '@texas/api/endpoints/userApi';
import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { userTypeFriendlyName } from '@texas/utils/helpers/roleHelpers';
import { TFunction } from 'i18next';

export function getUserTypeLabel(
  type: UserType | null,
  customType: string | null,
  t: TFunction,
) {
  return type
    ? userTypeFriendlyName(ensureEnumNumber(UserType, type), t)
    : customType;
}
